// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__fa591e22b7ff6087e363","cls2":"SimplePaperPodcast-cls2___b21da433e5bd4a0492d SimplePaperPodcast-cls1__fa591e22b7ff6087e363"};